import { useEffect, useState } from "react";
import { parseEther } from "viem";
import { useSendTransaction, useWaitForTransactionReceipt } from "wagmi";
import { Flame } from "lucide-react";
import { cronosMainnet } from "@/wagmi";
import { valleyDeposit } from "@/api";

export const LoadCroCard = ({ address, splitter, showToast, onLoaded }) => {
  const [amount, setAmount] = useState("5");
  const [verifying, setVerifying] = useState(false);
  const { data: hash, sendTransaction, isPending, error, reset } = useSendTransaction();
  const receipt = useWaitForTransactionReceipt({ hash });

  useEffect(() => {
    if (!receipt.isSuccess || !hash) return;
    setVerifying(true);
    showToast("Transaction confirmed. Crediting your farm…");
    valleyDeposit(address, hash)
      .then((r) => { showToast(`+${r.cro_loaded} CRO loaded into your farm`); onLoaded(r.state); reset(); })
      .catch((e) => showToast(e?.response?.data?.detail || "Deposit verification failed", "error"))
      .finally(() => setVerifying(false));
  }, [receipt.isSuccess]); // eslint-disable-line

  const load = () => {
    const n = Number(amount);
    if (!n || n <= 0) return showToast("Enter a positive CRO amount", "error");
    showToast("Confirm the transaction in your wallet…");
    sendTransaction({ to: splitter, value: parseEther(String(n)), chainId: cronosMainnet.id });
  };

  const busy = isPending || receipt.isLoading || verifying;
  return (
    <div className="card-tile card-flame" data-testid="valley-load-cro-card">
      <h3 className="font-display text-lg font-bold flex items-center gap-2"><Flame size={18} className="text-orange-500" /> Load CRO</h3>
      <p className="text-xs text-slate-400 mt-1">One wallet transaction through the burn splitter: 99% burned, 1% to the treasury. Your farm balance is credited with the full amount and seeds are then bought instantly.</p>
      <div className="mt-3 flex gap-2">
        <input data-testid="valley-load-amount-input" type="number" min="0.1" step="1" value={amount} onChange={(e) => setAmount(e.target.value)}
          className="bg-[#12131C] border border-[#2A2E45] rounded-xl px-3 py-2 w-24 font-mono text-sm" />
        <button data-testid="valley-load-cro-button" onClick={load} disabled={busy || !splitter} className="btn-tactile btn-flame text-sm flex-1">
          {isPending ? "Confirm in wallet…" : receipt.isLoading ? "Confirming…" : verifying ? "Crediting…" : "Burn & Load"}
        </button>
      </div>
      {hash && <a className="text-xs text-cyan-400 underline mt-2 inline-block" href={`https://explorer.cronos.org/tx/${hash}`} target="_blank" rel="noreferrer" data-testid="valley-load-tx-link">View tx ↗</a>}
      {error && <div className="mt-2 text-rose-400 text-xs" data-testid="valley-load-error">{error.shortMessage || error.message}</div>}
    </div>
  );
};
